// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1fs45","notes":"Notes_notes__1aJUc","note":"Notes_note__lfZBM","markdown":"Notes_markdown__UpIiM"};